import PropTypes from 'prop-types';
import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';

import styles from './shortcodePixel.css';

const ShortcodePixel = ({ url }) => (
  <img
    alt="Shortcode Pixel"
    className={styles.shortcodePixel}
    src={url}
  />
);

ShortcodePixel.propTypes = {
  url: PropTypes.string.isRequired,
};

const wrapWithStyles = withStyles(styles);
export default wrapWithStyles(ShortcodePixel);
